
export default {
    onText:'Sí',
    offText:'No'
};